/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StageTypeEnum } from './StageTypeEnum';
import {
    StageTypeEnumFromJSON,
    StageTypeEnumFromJSONTyped,
    StageTypeEnumToJSON,
    StageTypeEnumToJSONTyped,
} from './StageTypeEnum';
import type { SubscriptionStatusEnum } from './SubscriptionStatusEnum';
import {
    SubscriptionStatusEnumFromJSON,
    SubscriptionStatusEnumFromJSONTyped,
    SubscriptionStatusEnumToJSON,
    SubscriptionStatusEnumToJSONTyped,
} from './SubscriptionStatusEnum';

/**
 * Serializer for Stage model with validation.
 * @export
 * @interface PatchedStage
 */
export interface PatchedStage {
    /**
     * 
     * @type {string}
     * @memberof PatchedStage
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStage
     */
    venue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStage
     */
    readonly venueName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStage
     */
    readonly teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStage
     */
    name?: string;
    /**
     * Maximum audience capacity
     * @type {number}
     * @memberof PatchedStage
     */
    capacity?: number | null;
    /**
     * 
     * @type {StageTypeEnum}
     * @memberof PatchedStage
     */
    stageType?: StageTypeEnum;
    /**
     * Stage technical specs: dimensions, sound system, lighting, etc.
     * @type {any}
     * @memberof PatchedStage
     */
    technicalSpecs?: any | null;
    /**
     * 
     * @type {SubscriptionStatusEnum}
     * @memberof PatchedStage
     */
    subscriptionStatus?: SubscriptionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedStage
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedStage
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PatchedStage
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedStage
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the PatchedStage interface.
 */
export function instanceOfPatchedStage(value: object): value is PatchedStage {
    return true;
}

export function PatchedStageFromJSON(json: any): PatchedStage {
    return PatchedStageFromJSONTyped(json, false);
}

export function PatchedStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedStage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'venue': json['venue'] == null ? undefined : json['venue'],
        'venueName': json['venue_name'] == null ? undefined : json['venue_name'],
        'teamName': json['team_name'] == null ? undefined : json['team_name'],
        'name': json['name'] == null ? undefined : json['name'],
        'capacity': json['capacity'] == null ? undefined : json['capacity'],
        'stageType': json['stage_type'] == null ? undefined : StageTypeEnumFromJSON(json['stage_type']),
        'technicalSpecs': json['technical_specs'] == null ? undefined : json['technical_specs'],
        'subscriptionStatus': json['subscription_status'] == null ? undefined : SubscriptionStatusEnumFromJSON(json['subscription_status']),
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedStageToJSON(json: any): PatchedStage {
      return PatchedStageToJSONTyped(json, false);
  }

  export function PatchedStageToJSONTyped(value?: Omit<PatchedStage, 'id'|'venue_name'|'team_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'venue': value['venue'],
        'name': value['name'],
        'capacity': value['capacity'],
        'stage_type': StageTypeEnumToJSON(value['stageType']),
        'technical_specs': value['technicalSpecs'],
        'subscription_status': SubscriptionStatusEnumToJSON(value['subscriptionStatus']),
        'description': value['description'],
        'is_active': value['isActive'],
    };
}

